const state = {
  menuData: []
};

const mutations = {
  setMenuData(state, data) {
    state.menuData = data;
  }
};

const actions = {
  setMenuData({ commit }, data) {
    commit('setMenuData', data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
